import LoginSliderComponent from "../Components/Sliders/LoginSliderComponent";
import { useAppContext } from "../AppContext";



function LoginPage() {

    const app = useAppContext();



  return (
      <div className="login-wrapper">
          {/* <!-- row start --> */}
          <div className="row g-0">
              {/* <!-- single item start --> */}
              <div className="col-lg-6 text-center">
                  <div className="lg-right">
                      <div className="lg-right-inner">
                          <img src="/static/img/logo.png" alt="img" className="img-fluid" />
                          <h4>تسجيل الدخول</h4>
                          <form className="text-end">
                              {/*  <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" className="form-label">اسم المستخدم</label>
                                    <input type="email" className="form-control" id="exampleInputEmail1"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputPassword1" className="form-label">كلمة المرور</label>
                                    <input type="password" className="form-control" id="exampleInputPassword1"/>
                                </div> */}
                              <div className="text-center">

                                  <button onClick={app.signIn!} type="button" className="btn">دخول Microsoft 365</button>

                              </div>
                          </form>
                      </div>
                  </div>
              </div>
              {/* <!-- single item end --> */}
              {/* <!-- single item start --> */}
              <div className="col-lg-6">
                  <div className="item-left">
                      <div className="log-itop">
                          <h1>رافد</h1>
                          <h2> تطوير لخدمات النقل </h2>
                      </div>
                      <LoginSliderComponent />
                      <footer className="footer footer-login">
                          <div className="row g-0">

                              <div className="col-4">
                                  <div className="lg-footer-logo">
                                      <a href="/">
                                          <img src="/static/img/footer-logo.png" alt="img" className="img-fluid" />
                                      </a>
                                  </div>
                              </div>
                              <div className="col-8 text-start align-self-end">
                                  <ul>
                                  <li><a href="https://www.rafedsa.com"><img src="/static/img/website.png" alt="" /></a></li>
                        <li><a href="https://www.youtube.com/c/TatweerTC"><img src="/static/img/YouTube.png" alt=""/></a></li>
                        <li><a href="https://www.instagram.com/rafedsaudi/"><img src="/static/img/Instagram.png" alt=""/></a></li>
                        <li><a href="https://twitter.com/rafedsaudi"><img src="/static/img/Twitter.png" alt=""/></a></li>


                                  </ul>
                              </div>
                          </div>
                      </footer>
                  </div>
              </div>
              {/* <!-- single item end --> */}

          </div>
          {/* <!-- row end --> */}
      </div>
  );
}

export default LoginPage;
